import { render, staticRenderFns } from "./list-img.vue?vue&type=template&id=5ed5e022&scoped=true&"
import script from "./list-img.vue?vue&type=script&lang=js&"
export * from "./list-img.vue?vue&type=script&lang=js&"
import style0 from "./list-img.vue?vue&type=style&index=0&id=5ed5e022&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed5e022",
  null
  
)

export default component.exports